export default "__VITE_ASSET__5f1a1daa__"